//Install
import React from "react";
//Install
import ReactDOM from "react-dom/client";
//Install
import App from "./App";
//Install
import reportWebVitals from "./reportWebVitals";

//Element
const root = ReactDOM.createRoot( document.getElementById( "root" ) );
//Element
root.render(
  //Element
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
//Element
reportWebVitals();